module.exports = __webpack_public_path__ + "img/bobau_bobocoin.gm.a50c4f0.png";